import type { CSSProperties } from 'react';

import classNames from 'classnames';

import type { Author } from '../../types';
import { postCardAuthorsText } from '../Post.css';

interface Props {
  className?: string;
  authors: Author[];
  displayImages?: boolean;
  displayText?: boolean;
  authorsTextTransform?: string;
  authorsFontSize?: string;
  truncateList?: boolean;
  authorStyle?: CSSProperties;
  authorContainerStyle?: CSSProperties;
  alignment?: 'left' | 'center' | 'right';
  byLineText?: string;
}

const ALIGN_OPTIONS = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

const TEXT_ALIGN_OPTIONS = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

const Authors = ({
  className,
  authors,
  authorsTextTransform,
  displayImages,
  displayText,
  truncateList,
  authorsFontSize,
  alignment,
  byLineText,
}: Props) => {
  const authorCount = authors.length;
  const hasAuthors = authorCount > 0;
  const firstAuthorName = authors[0]?.name;

  const hasMultipleAuthors = authorCount > 1;
  const multipleAuthorsText = truncateList
    ? `${firstAuthorName}, +${authors.length - 1}`
    : authors.map((author) => author.name).join(', ');

  const authorsText = hasMultipleAuthors ? `${multipleAuthorsText}` : firstAuthorName;
  const adjustedByLineText = byLineText ? `${byLineText} ${authorsText}` : authorsText;

  return (
    <div className={classNames('flex flex-row w-full flex-wrap gap-1', className, ALIGN_OPTIONS[alignment || 'left'])}>
      {displayImages && (
        <div className="flex -space-x-1.5 overflow-hidden">
          {authors?.map((author) => {
            const fillColor = '#ffffff';
            return (
              <div key={author?.id} className="rounded-full h-7 w-7">
                <img
                  className="inline-block object-cover rounded-full h-7 w-7"
                  src={author.profile_picture.url}
                  alt={author.name}
                  style={{
                    border: `1px solid ${fillColor}`,
                  }}
                />
              </div>
            );
          })}
        </div>
      )}

      {displayText && hasAuthors && (
        <div className={classNames('flex items-center', ALIGN_OPTIONS[alignment || 'left'])}>
          <span
            className={classNames(
              postCardAuthorsText,
              authorsFontSize || 'text-xs',
              TEXT_ALIGN_OPTIONS[alignment || 'left'],
              authorsTextTransform,
            )}
          >
            {adjustedByLineText}
          </span>
        </div>
      )}
    </div>
  );
};

export default Authors;
